export default "__VITE_ASSET__COQOX_1p__"